import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { AccountStatus, User } from 'app/models/user';
import { UserService } from "app/services/user.service";
import { ModalDirective, ToastService, SidenavComponent } from "ng-uikit-pro-standard";
import { finalize, filter } from 'rxjs/operators';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Storage } from 'app/models/storage';
import { StorageService } from 'app/services/storage.service';
import { ValidationHandler } from 'app/helpers/validation.handler';
import { Router, NavigationStart, NavigationEnd, ActivatedRoute } from '@angular/router';
import { WorkflowExecutionService } from 'app/services/workflow-execution.service';
import { Dashboard } from 'app/models/dashboard';
import { DashboardService } from 'app/services/dashboard.service';
import moment from 'moment';
import { getSpecialPages, isSpecialPage } from 'app/helpers/utils';



@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit, AfterViewInit {
  @ViewChild('sidenav', { static: false }) sidenav: SidenavComponent;

  clicked: boolean;
  currentUser: User;
  searchText: string = '';

  // User Profile variables
  @ViewChild('userProfileModal', { static: true }) userProfileModal: ModalDirective;
  @ViewChild('completeRegistrationModal', { static: true }) completeRegistrationModal: ModalDirective;

  isAvatarUploading: boolean = false;
  isChangingPassword: boolean = false;
  isLoadingUser: boolean = false;
  isSavingUser: boolean = false;
  isCompletingInfo: boolean = false;
  isAskingForMFA: boolean = false;
  avatarRandomizer: number = 1;
  editUserForm: FormGroup;
  showLeftNavbar: boolean = true;
  tasksCount: number = 0;

  storageList: Storage[] = [];
  dashboardsList: Dashboard[] = [];
  pathName: string = '';

  currentUserQRCodeUrl: string = null;
  isLoadingQRCodeUrl: boolean = false;
  mfaCodeFormGroup: FormGroup = null;
  isMFAActive: boolean = false;

  completeRegistrationFormGroup: FormGroup = null;
  isCompletingRegistration: boolean = false;

  constructor(public userService: UserService, private formBuilder: FormBuilder,
              private storageService: StorageService, private _validationHandler: ValidationHandler,
              private toastService: ToastService, private router: Router, private workflowExecutionService: WorkflowExecutionService,
              private dashboardService: DashboardService, private validationHandler: ValidationHandler) {                
    this.clicked = this.clicked === undefined ? false : true;

    this.editUserForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      current_password: [''],
      new_password: ['', Validators.minLength(6)],
      new_password_confirmation: [''],
    });

    this.mfaCodeFormGroup = this.formBuilder.group({
      code: ['', [Validators.required, Validators.minLength(6)]]
    });

    let pathname = document.location.pathname;
    this.pathName = pathname;
        if (this.currentUser && this.currentUser.email_verified_at == null && (pathname != "/verify-email" && pathname != "/reset-password" && pathname != "/login")) {
          // make sure we have the updated user before show the notification
          this.userService.getCurrent().subscribe(user=> {
            if (user.email_verified_at == null) {
              let options = { extendedTimeOut: 0, timeOut: 0, closeButton: true, actionButton: "Resend Verification Email" };
              let action = this.toastService.warning('Email address is not verified yet', '', options);
              action.onAction.subscribe(() => {
                this.verifyMail();
              });  
            }
          });
        }
    /** @todo handle error */
    this.storageService.allStoragesSubject.subscribe((list)=>this.storageList=list);

    this.dashboardService.currentDashboardsSubject.subscribe((d) => this.dashboardsList = d);
    
    // User Profile Stuff
    this.avatarRandomizer = Math.random() * 10000000000;

    this.userService.currentUser.subscribe(user => {
      this.currentUser = user;

      this.editUserForm.controls.name.setValue((user.name && user.name != user.email) ? user.name : '');
      this.editUserForm.controls.email.setValue(user.email);

      this.currentUserQRCodeUrl = null;
      this.isMFAActive = user.activated_2fa;
      this.mfaCodeFormGroup.reset();

      this.loadCurrentUserQRCodeUrl();

      if (user) {
        (window as any).Echo.private(`${user.company_id}.user.${user.id}`).listen('UserTaskCountChanged', (e) => {
          this.tasksCount = e.newTaskCount;
        });
      }
    });
  }

  ngOnInit() {
    this.searchText = '';

    this.workflowExecutionService.getMyTasksCount().subscribe((r) => this.tasksCount = r.count);
  }

  ngAfterViewInit() {
    
    var oldShowOverlay = this.sidenav.showOverlay;
    this.sidenav.showOverlay = () => {
      document.body.classList.add('sidenav-open');
      oldShowOverlay.bind(this.sidenav)();
    };

    var oldhideOverlay = this.sidenav.hideOverlay;
    this.sidenav.hideOverlay = () => {
      document.body.classList.remove('sidenav-open');
      oldhideOverlay.bind(this.sidenav)();
    };

      setTimeout(() => {
        let user = this.userService.currentUserValue;
        if (user) {  
          if (user.invite_token && !this.isCompletingInfo) {
            this.isCompletingInfo = true;
            if (!isSpecialPage() && !this.userProfileModal.isShown)
              this.userProfileModal.show();
          }

          if (!user.activated_2fa && user.is_mfa_required) {
            this.isAskingForMFA = true;
            if (!isSpecialPage() && !this.userProfileModal.isShown)
              this.userProfileModal.show();
          }

          if (user.account_status == AccountStatus.ACCOUNT_STATUS_NEW_REGISTRATION) {
            if (!isSpecialPage() && !this.completeRegistrationModal.isShown) {
              this.completeRegistrationFormGroup = this.formBuilder.group({
                name: ['', Validators.required],
                company_name: ['', Validators.required]
              });
              this.completeRegistrationModal.show();
            }
          }
        }          
      }, 1);

  }

  openUserProfile() {
    let user = this.userService.currentUserValue;
    this.editUserForm.controls.name.setValue((user.name && user.name != user.email) ? user.name : '');
    this.editUserForm.controls.email.setValue(user.email);

    this.userProfileModal.show();
  }

  onCompleteRegistration() {
    this.validationHandler.onSubmitCheck(this.completeRegistrationFormGroup);
    if (!this.completeRegistrationFormGroup.valid) {
      return;
    }

    this.isCompletingRegistration = true;
    this.userService.completeRegistration(this.completeRegistrationFormGroup.get('name').value, 
                                          this.completeRegistrationFormGroup.get('company_name').value).pipe(finalize(() => {
                                            this.isCompletingRegistration = false;
                                          })).subscribe(() => {
                                            this.userService.getCurrent().subscribe();
                                            this.completeRegistrationModal.hide();
                                          });
  }

  loadCurrentUserQRCodeUrl() {
    this.isLoadingQRCodeUrl = true;
    this.userService.getMFAQRCodeUrl().pipe(finalize(() => {
      this.isLoadingQRCodeUrl = false;
    })) .subscribe((r) => {
      this.currentUserQRCodeUrl = r.url;
    }, () => {
      if (this.userProfileModal.isShown)
        this.toastService.error('Unable to get QR Code');
    });
  }

  activateMFA() {
    this.validationHandler.onSubmitCheck(this.mfaCodeFormGroup);
    if (!this.mfaCodeFormGroup.valid) {
      return;
    }

    this.isLoadingQRCodeUrl = true;
    this.userService.activateMFA(this.mfaCodeFormGroup.get('code').value).pipe(finalize(() => {
      this.isLoadingQRCodeUrl = false;
    })) .subscribe((r) => {
      this.toastService.success('Activated MFA!');
      this.isMFAActive = true;
      this.mfaCodeFormGroup.reset();
    }, err => {
      this.validationHandler.serverValidationHandler(err, this.mfaCodeFormGroup);
    });
  }

  deactivateMFA() {
    this.isLoadingQRCodeUrl = true;
    this.userService.deactivateMFA().pipe(finalize(() => {
      this.isLoadingQRCodeUrl = false;
    })) .subscribe((r) => {
      this.toastService.success('Deactivated MFA!');
      this.isMFAActive = false;
    }, err => {
      this.toastService.error('Error deactivating MFA!');
    });
  }

  setClicked(val: boolean): void {
    this.clicked = val;
  }

  logout() {
    this.userService.logout();
  }


  verifyMail() {
    this.userService.sendVerificationMail().subscribe(v => {
      this.toastService.success('Verification Email Sent!');
    }, (err) => {
      if (err.status === 422)
        this.toastService.error(err.message);
      else
        this.toastService.error("Failed to verify email address!")
    });

  }
  onCloseUserProfile() {
    this.isChangingPassword = false;
    this.isSavingUser = false;
    this.editUserForm.reset();
    this.mfaCodeFormGroup.reset();
  }
  
  isLeadingTeam(team) {
    return this.currentUser.leading_teams.find(t => t.name == team.name);
  }

  beginSearch() {
    this.router.navigate(['/search'], {queryParams: {
      options: JSON.stringify({
          query: this.searchText,
          is_files: true,
            is_user_storage: true,
            is_global_storage: true,
            in_file_contents: true,
            is_forms: true,
            in_form_contents: true,
            is_data: true
      })
    }});
    this.searchText = '';
  }

  onSaveUser() {
    // post save user
    this.isSavingUser = true;
    if(!this.editUserForm.valid)
    {
      this._validationHandler.onSubmitCheck(this.editUserForm);
      this.isSavingUser = false;
      return ;
    }

    let userClone: User = { ...this.currentUser };
    userClone.name = this.editUserForm.value.name;
    userClone.email = this.editUserForm.value.email;

    // handle password change also
    if (this.isCompletingInfo) {
      userClone.new_password = this.editUserForm.value.new_password;
    } else if (this.isChangingPassword) {
      userClone.old_password = this.editUserForm.value.current_password;
      userClone.new_password = this.editUserForm.value.new_password;
    }

    this.userService.update(userClone).pipe(finalize(() => {
      this.isSavingUser = false;
    })).subscribe(x => {
      /** @todo handle errors */
      this.isCompletingInfo = false;
      this.userProfileModal.hide();
      this.userService.getCurrent().subscribe();
    }, err => {
      /** @todo handle error */
      
      this._validationHandler.serverValidationHandler(err, this.editUserForm);
      this.isSavingUser = false;

    });
  }

  onRemoveAvatar() {
    /** @todo handle error */
    this.userService.removeUserAvatar().subscribe(() => {
      this.avatarRandomizer = Math.random() * 10000000000;

      // update current user
      this.userService.getCurrent().subscribe();
    });
  }
  onChangeAvatar(event) {
    this.isAvatarUploading = true;
    var file: File = event.srcElement.files[0];

    /** @todo check maximum file size here */

    // upload avatar and load it in image
    this.userService.uploadAvatar(file).pipe(finalize(() => {
      this.isAvatarUploading = false;
      event.srcElement.value = "";
    })).subscribe(u => {
      this.avatarRandomizer = Math.random() * 10000000000;
      // update current user
      this.userService.getCurrent().subscribe();
      /** @todo handle error */
    });
  }
  toggleNav(e){
  }
}
